import { useState, useCallback } from "react";

/**
 * Manages row selection and edit/delete/reset modals for paginated DataTable screens.
 * Resets all modal state when pagination changes so dialogs stay in sync with the current page.
 */
export function useTableSelectionModals() {
  const [selectedItem, setSelectedItem] = useState(null);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openReset, setOpenReset] = useState(false);

  const handleEdit = useCallback((item) => {
    setSelectedItem(item);
    setOpenEdit(true);
  }, []);

  const handleDelete = useCallback((item) => {
    setSelectedItem(item);
    setOpenDelete(true);
  }, []);

  const handleReset = useCallback((item) => {
    setSelectedItem(item);
    setOpenReset(true);
  }, []);

  const handleCloseDelete = useCallback(() => {
    setOpenDelete(false);
    setSelectedItem(null);
  }, []);

  const handleCloseEdit = useCallback(() => {
    setOpenEdit(false);
    setSelectedItem(null);
  }, []);

  const handleCloseReset = useCallback(() => {
    setOpenReset(false);
    setSelectedItem(null);
  }, []);

  const onPaginationChange = useCallback(() => {
    setOpenDelete(false);
    setOpenEdit(false);
    setOpenReset(false);
    setSelectedItem(null);
  }, []);

  return {
    selectedItem,
    setSelectedItem,
    openEdit,
    setOpenEdit,
    openDelete,
    setOpenDelete,
    openReset,
    setOpenReset,
    handleEdit,
    handleDelete,
    handleReset,
    handleCloseDelete,
    handleCloseEdit,
    handleCloseReset,
    onPaginationChange,
  };
}
